
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';

@Component
export default class YoutubeLinks extends Vue {
  // Prop: 부모로부터 youtubeList를 받습니다.
  @Prop({
    type: Array,
    default: () => [''],
  })

  readonly youtubeList!: string[];

  // ⭐️ [추가] 라벨/제목을 제어하는 Prop
  @Prop({ type: String, default: 'IR유튜브 영상' })
  readonly componentLabel!: string;

  // ⭐️ [추가] placeholder를 제어하는 Prop
  @Prop({ type: String, default: '아이디 입력' })
  readonly componentPlaceholder!: string;

  // Local State: 배열 조작을 위해 로컬 복사본을 사용합니다.
  private localYoutubeList: string[] = [];

  @Watch('youtubeList', { immediate: true })
  onYoutubeListChange(newVal: string[]) {
    if (!newVal || newVal.length === 0) {
      this.localYoutubeList = [''];
    } else {
      this.localYoutubeList = [...newVal];
    }
  }

  private updateParent() {
    this.$emit('update:youtubeList', this.localYoutubeList);
  }

  private updateYoutubeLink(index: number, value: string) {
    this.$set(this.localYoutubeList, index, value);
    this.updateParent();
  }

  private handleClickAddYoutube() {
    if (this.localYoutubeList.length >= 3) {
      // eslint-disable-next-line no-alert
      alert('유튜브 영상은 최대 3개까지 등록 가능합니다.');
      return;
    }
    this.localYoutubeList.push('');
    this.updateParent();
  }

  private handleClickRemoveYoutube(index: number) {
    this.localYoutubeList.splice(index, 1);
    this.updateParent();
  }
}
